import { ExperienceOption } from '@/types'
import { requests, responseBody } from '../http/axios'
import { snakeCaseObject } from '@/helper/formatter'

export const ExperienceOptionService = {
  createOption: async (
    experienceUuid: string,
    option: ExperienceOption & { isInformationPage?: boolean }
  ): Promise<ExperienceOption> =>
    await requests
      .post(`experiences/${experienceUuid}/options`, snakeCaseObject(option))
      .then(responseBody),

  updateOption: async (
    experienceUuid: string,
    option: ExperienceOption & { isInformationPage?: boolean }
  ): Promise<ExperienceOption> =>
    await requests
      .put(
        `experiences/${experienceUuid}/options/${option.id}`,
        snakeCaseObject(option)
      )
      .then(responseBody),

  removeOption: async (
    experienceUuid: string,
    option: ExperienceOption
  ): Promise<void> =>
    await requests.delete(`experiences/${experienceUuid}/options/${option.id}`),

  getAvailableSlots: async (
    optionId: string,
    date: string,
    locale?: string,
    // DEV-730: the operator "Book Now" / reschedule flows opt in to bypass the
    // experience cutoff. Public store/widget pages omit it so the cutoff is
    // enforced even when a logged-in operator's token leaks onto the page.
    bookNow?: boolean
  ): Promise<string[]> =>
    await requests.post(
      `options/${optionId}/available_slots/${date}${
        locale ? `?locale=${locale}` : ''
      }`,
      bookNow ? { book_now: true } : {}
    ),

  getAvailablePrices: async (
    optionId: string,
    date: string,
    slot: string,
    locale?: string,
    componentSelections?: {
      componentOptionId: number
      date: string
      slot: string
    }[]
  ): Promise<Record<string, number>> =>
    await requests.post(
      `options/${optionId}/available_prices/${date}/${slot}${
        locale ? `?locale=${locale}` : ''
      }`,
      componentSelections ? { component_selections: componentSelections } : {}
    ),

  getAvailableVoucherPrices: async (
    optionId: string,
    locale?: string
  ): Promise<Record<string, number>> =>
    await requests.post(
      `options/${optionId}/available_voucher_prices${
        locale ? `?locale=${locale}` : ''
      }`,
      {}
    ),
}
